import type {OtherLeaderboardRows} from 'shells/leaderboard/types';

import type {GetChatbotReport_chatbotReport_aiMetrics_commonTopics as Topic} from 'nutshell-graphql-types';

export function mapTopicsToLeaderboardRows(
    topics: Topic[],
    handleOpenTopic: (topic: Topic) => void
): OtherLeaderboardRows {
    return topics.map((topicData, index) => {
        return {
            id: `${topicData.topic}-${index}`,
            rowType: 'other',
            label: topicData.topic,
            value: `${topicData.threadCount} ${topicData.threadCount === 1 ? 'thread' : 'threads'}`,
            onClick: () => handleOpenTopic(topicData),
        };
    });
}

export function formatPageSlugs(slugs: string[]): string {
    if (slugs.length === 0) {
        return '';
    }

    const additional = slugs.length - 1;
    return additional > 0 ? `${slugs[0]}, +${additional}` : slugs[0] ?? '';
}
